module.exports = __webpack_public_path__ + "img/business12_E.88222fc6.png";